module.exports = __webpack_public_path__ + "static/media/wine_packages.8fcaf333.jpg";